export default "__VITE_ASSET__CP2iH$5i__"